import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { DISABLE_MODULE } from "./gql";

const useDisableModule = createDefaultMutationHook(DISABLE_MODULE);

export default useDisableModule;
